import { ReadClient, WriteClient } from "@/types/client";
import { APIService } from "@/services/api";
import { API } from "@/lib/api";

export const ClientService = new APIService<ReadClient, WriteClient>(
  API.Clients,
);
